module.exports = __webpack_public_path__ + "static/media/617EchoStNW_2018-06-25_129.d55ce55a.jpg";